
import { Component, Vue } from 'vue-property-decorator';
import { VueGithubCorners } from 'vue2-github-corners';

import VueYandexShare, {
  COLOR_SCHEMES,
  COPY_POSITIONS,
  DIRECTIONS,
  LANGUAGES,
  POPUP_DIRECTIONS,
  POPUP_POSITIONS,
  SERVICES,
  SHAPES,
  SIZES,
} from '@/components/vue-yandex-share';
import WrapperDemo from '@/components/wrapper-demo';

@Component<App>({
  components: { VueYandexShare, VueGithubCorners, WrapperDemo },

  mounted() {
    console.log(process.env.npm_package_version);
  },
})
export default class App extends Vue {
  /**
   * Параметры компонента VueYandexShare
   */
  options: { [key: string]: any } = {
    bare: false,
    colorScheme: 'normal',
    copy: 'last',
    curtain: true,
    description: null,
    direction: 'horizontal',
    hashtags: 'vue,social',
    image: null,
    lang: 'ru',
    limit: SERVICES.length,
    moreButtonType: null,
    nonce: '',
    popupDirection: 'bottom',
    popupPosition: 'inner',
    services: ['facebook', 'telegram', 'twitter', 'vkontakte'],
    shape: 'normal',
    size: 'm',
    title: null,
    url: null,
    useLinks: false,
  };

  COLOR_SCHEMES = COLOR_SCHEMES;
  COPY_POSITIONS = COPY_POSITIONS;
  DIRECTIONS = DIRECTIONS;
  LANGUAGES = LANGUAGES;
  POPUP_DIRECTIONS = POPUP_DIRECTIONS;
  POPUP_POSITIONS = POPUP_POSITIONS;
  SERVICES = SERVICES;
  SHAPES = SHAPES;
  SIZES = SIZES;
}
